// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * The `CalendarCell` component is internally used for rendering the items in the current view. Also be used as a custom `cell` of the [Calendar]({% slug api_dateinputs_native_calendarprops %}#toc-cell).
 *
 * * [Customizing the cells inside the Calendar view]({% slug custom_rendering_calendar_native %}#toc-cells-inside-the-view)
 */

var CalendarHeaderTitle = {
  name: 'KendoHeaderTitle',
  // @ts-ignore
  emits: {
    'click': null
  },
  props: {
    id: String,
    value: String,
    view: Number
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },

  /**
   * @return
   * Returns a `<button />` element with the [`value`]({% slug api_dateinputs_calendarheadertitleprops %}#toc-value) of the title as a child.
   */
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("button", {
      value: this.$props.value,
      attrs: this.v3 ? undefined : {
        value: this.$props.value,
        id: this.$props.id,
        tabindex: 0
      },
      id: this.$props.id,
      onClick: this.handleClick,
      on: this.v3 ? undefined : {
        "click": this.handleClick
      },
      tabindex: 0
    }, [defaultSlot]);
  }
};
export { CalendarHeaderTitle };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dateinputs/dist/es/calendar/components/CalendarHeaderTitle.js
// module id = 357
// module chunks = 93